import {ChangeDetectionStrategy, ChangeDetectorRef, Component,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FormFieldGroupConfig} from "../../../../../model/api/form-field-group-config";
import {CcBaseComponent} from "../../../../../crystal-elements/cc-base.component";
import {FormFieldConfig} from "../../../../../model/api/form-field-config";
import {Trade} from "../../../../../model/clearing/trade";
import TYPE = FormFieldConfig.TYPE;

@Component({
  selector: 'app-clearing-trade-detail',
  templateUrl: './trade-detail.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TradeDetailComponent extends CcBaseComponent {

  transPartKey: string = 'clearing.trade';

  formRecord: any;
  detailDialogVisible: boolean;

  detailFormConfig: FormFieldGroupConfig[];

  constructor(cdref: ChangeDetectorRef,
              messageService: MessageService,
              translateService: TranslateService) {
    super(cdref, messageService, translateService);
  }

  protected initConfigs() {
    super.initConfigs();

    this.detailFormConfig = [{
      // group: 'detail',
      fields: [
        {
          field: 'businessDate',
          column: 2,
          type: TYPE.DATE
        },
        {
          field: 'clearingDate',
          column: 2,
          type: TYPE.DATE
        },
        {
          field: 'customOrderReference',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'clearingHouse',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'exchangeCode',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'contractCode',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'maturity',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'side',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'exchangeReference',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'displayReference',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'orderReference',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'volume',
          column: 2,
          type: TYPE.INTEGER
        },
        {
          field: 'price',
          column: 2,
          type: TYPE.DECIMAL
        },
        {
          field: 'avgPrice',
          column: 2,
          type: TYPE.DECIMAL
        },
        {
          field: 'avgPriceGroupId',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'account',
          column: 2,
          type: TYPE.TEXT,
          mapValue: (record) => record.account ? record.account.name : ''
        },
        {
          field: 'state',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'type',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'strategy',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'overrideAvgPrice',
          column: 2,
          type: TYPE.DECIMAL
        },
        {
          field: 'avgPriceResidual',
          column: 2,
          type: TYPE.DECIMAL
        },
        {
          field: 'avgPriceResidualGroup',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'avgPriceResidualAlloc',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'avgRndPrice',
          column: 2,
          type: TYPE.DECIMAL
        },
        {
          field: 'avgPriceResidualCurrency',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'unmatchedVolume',
          column: 2,
          type: TYPE.INTEGER
        },
        {
          field: 'openClose',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'callPut',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'strike',
          column: 2,
          type: TYPE.DECIMAL
        },
        {
          field: 'giveUpBrokerCode',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'giveUpMessage',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'giveupMessage2',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'giveupMessage3',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'giveupAccountType',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'origineTrader',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'trader',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'tradingEnvironment',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'clearingBroker',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'creationDate',
          column: 2,
          type: TYPE.DATETIME
        },
        {
          field: 'modificationDate',
          column: 2,
          type: TYPE.DATETIME
        },
        {
          field: 'executionDate',
          column: 2,
          type: TYPE.DATETIME
        },
        {
          field: 'freeText1',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'freeText2',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'freeText3',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'freeText4',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'customFreeTextField1',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'customFreeTextField2',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'customFreeTextField3',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'customFreeTextField4',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'alertText',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'id',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'parentId',
          column: 2,
          type: TYPE.TEXT
        },]
    }];
  }

  public open(selectedItem: Trade): void {
    this.formRecord = selectedItem;
    this.detailDialogVisible = true;
    this.cdref.detectChanges();
  }
}
